import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/Comment/config';
import cn from 'classnames';
import s from './Comment.scss';
const CommentViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "comment",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
CommentViewer.displayName = 'CommentViewer';
export default CommentViewer;

//# sourceMappingURL=Comment.js.map